import { Navigate, Route, Routes } from "react-router-dom";
import { Administration } from "./Administration";
import { ContractType } from "./ContractType";
import { JobZone } from "./JobZone/JobZone";
import { Inventory } from "./Inventory/Inventory";
import { PrivateRoute } from "../../keycloak";
import { UserRoles } from "../../constants/userRoles";
import { Integrations } from "./Integrations/Integrations";

export const AdminView = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.CONTRACT_TYPE_VIEW],
            }}
          />
        }
      >
        <Route path="/contract-type" element={<ContractType />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.INTEGRATION_VIEW],
            }}
          />
        }
      >
        <Route path="/integrations" element={<Integrations />} />
      </Route>
      <Route index path="/leads-form" element={<Administration />} />
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.JOB_ZONE_VIEW],
            }}
          />
        }
      >
        <Route path="/service-division" element={<JobZone />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.INVENTORY_VIEW],
            }}
          />
        }
      >
        <Route path="/inventory" element={<Inventory />} />
      </Route>
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
};
